import { CONTACT_US_FOR_BUSINESS } from "@/constants/events"
import { CONTACT_US_EMAIL, posthogService, RecallButton, useSnackbar } from "@recall/common"
import copyToClipboard from "copy-to-clipboard"
import { FC } from "react"
import { ButtonProps } from "./types"

export const ContactUsButton: FC<ButtonProps> = () => {
    const { showMessage } = useSnackbar()

    const handleContactUs = () => {
        posthogService.captureEvent(CONTACT_US_FOR_BUSINESS)
        copyToClipboard(CONTACT_US_EMAIL)
        showMessage("Email copied to clipboard.", { severity: "success" })
    }

    return (
        <RecallButton mode="secondary" size="large" onClick={handleContactUs} fullWidth>
            Contact us
        </RecallButton>
    )
}
